import { ScopeOfPracticeEnum } from '@umss/shared/utils';

// DTO for a contractor available for shifts
export interface AvailableContractorForShiftsDto {
  contractorId: string;
  firstName: string;
  lastName: string;
  email: string | null;
  phoneNumber: string | null;
  profilePictureUrl: string | null;
  scopeOfPractice: ScopeOfPracticeEnum;
  scopeOfPracticeDisplay: string;
  hourlyRate: number | null;
  distanceMiles: number | null;
  isFavorite: boolean;
  hasFacilityRequest: boolean; // Indicates that the facility has already sent a shift request to this contractor for at least one of the requested shift needs.
  hasContractorRequest: boolean; // Indicates that the contractor has already requested/applied for at least one of the requested shift needs.
}

// DTO for the response of available contractors for batch of shifts
export interface AvailableContractorsForShiftsResponseDto {
  shiftNeedIds: string[];
  contractors: AvailableContractorForShiftsDto[];
  totalCount: number;
}
